import { WidgetType } from '@/lib/analytics/widget/widget.type';
import { SIZE_FULL } from '@/lib/gridElements/size';

import { MediasWidget } from '@/components/pages/analyze/widget/MediasWidget';

export const postRankingConfig: WidgetType<typeof MediasWidget> = {
    title: 'chart.twitter.post_ranking',
    id: 'post_ranking',
    size: SIZE_FULL,
    sortFields: [
        'created', // Recent
        'impressions', // Impressions
        'likes', // Like
        'comments', // Reply
        'shares' // Repost
    ],
    disableXLSExport: true,
    type: 'widget',
    element: MediasWidget
};
